import * as MUTATION from "@/store/mutation-types";

const state = {
  project: {
    project_info: {
      laboratory_id: null,
      sample_type_id: null,
      test_package_id: null
    },
    submissions: []
  }
};

const getters = {
  project_info: state => state.project.project_info,
  submissions: state => state.project.submissions
};

const mutations = {
  PROJECT_INFO_SET: (state, { id, name }) => {
    state.project.project_info[name] = id;
    if (name === "sample_type_id" || name === "test_package_id") {
      state.project.submissions = [];
    }
  }
};

const actions = {
  SET_PROJECT_INFO: ({ commit }, data) => {
    commit(MUTATION.PROJECT_INFO_SET, data);
  }
};

export default {
  getters,
  mutations,
  actions,
  state
};
